import { useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

const defaultSize = 50

function usePaginatedLoader({ loadFn, entityKey, queryOptions = {} }){
  const dispatch = useDispatch()
  const offsetRef = useRef(0)

  const load = async (loadNext, overrides = {}) => {
    if (!loadNext) offsetRef.current = 0

    const size = overrides.size ?? defaultSize

    const result = await dispatch(loadFn({
      size,
      offset: offsetRef.current,
      sort: 'name asc',
      loadNext,
      ...queryOptions,
    }))

    if (result.success) {
      offsetRef.current += size
    }
    return result
  }

  const entitySlice = useSelector(reduxState => reduxState.entities[entityKey])
  const entityReducer = useSelector(reduxState => reduxState[entityKey])
  const { result: { hasMore } = {}, loading } = entityReducer || {}

  const items = useMemo(() => Object.values(entitySlice || {}), [entitySlice])

  return {
    items,
    loading,
    hasMore,
    callbacks: {
      loadInitialPage: overrides => load(false, overrides),
      loadNextPage: () => load(true),
    },
  }
}

export default usePaginatedLoader
